import { render, staticRenderFns } from "./verifySignUp.vue?vue&type=template&id=3011888a&scoped=true"
import script from "./verifySignUp.vue?vue&type=script&lang=js"
export * from "./verifySignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3011888a",
  null
  
)

export default component.exports